// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Gp-c","top":"styles_top__ETnuh"};